<template>
  <section class="chapter3">
    <div class="top">
      <Container>
        <CNumber>03</CNumber>
        <Title dark>Social media</Title>
        <Content dark>
          <p>Tijd voor lunch. En dus tijd om door Insta te scrollen. Jaloersmakend hè, al die vrienden met leuke banen en op verre reizen? Al die foto’s ben jij een paar seconden later weer vergeten. Maar met een depressie kun je alleen maar denken: ‘faler, niemand zal ooit jaloers op jou zijn. Wat heb jij nou bereikt?’</p>
        </Content>
      </Container>
      <SocialSimulation></SocialSimulation>
    </div>
    <div class="bottom">
      <Container>
        <Rorschach
          :poster="poster"
          :src="rorschach"
          light
        >
          Reyhan
          <AudioPlayer
            :src="audio"
            title="Luister naar Reyhan"
            person="reyhan"
            trackTitle="anekdote-reyhan"
          ></AudioPlayer>
        </Rorschach>
        <PersonContent>
          Ik was constant zenuwachtig. Een soort levenszenuwen voor alles wat er nog ging komen en of ik het wel goed ging doen. Ik vergrootte uit wat ik niet had. Ik kijk daarom maar heel kort op Instagram. Als ik te lang naar andere mensen kijk, dan word ik jaloers. Als je mensen ziet die de wereld over reizen, denk je: ik doe iets verkeerd. Ik kan alles helemaal kapot denken.
        </PersonContent>
        <Accordion :track="track">
          <template slot="explanation">
            <p>Perfectionisme speelt bij sommige vormen van depressie een grote rol. Degene die depressief is vergelijkt zichzelf met mensen in zijn of haar omgeving. Daarbij kijken ze vooral naar de goede eigenschappen van de ander en focussen ze bij zichzelf op hun tekortkomingen. Rumineren heet dat: alleen maar piekeren over wat niet goed gaat. Deze gedachten kunnen compleet de overhand nemen.</p>
          </template>
          <template slot="title">Wat zit daarachter?</template>
        </Accordion>
      </Container>
    </div>
  </section>
</template>

<script>
import { CNumber, Title, Content, Container, AudioPlayer } from '@/components/chapter'
import { Rorschach, PersonContent } from '@/components/person'
import Accordion from '@/components/Accordion'
import { SocialSimulation } from '@/components/social'
import media from '@/utils/media'
import { mediaQueryMixin, scrollPositionMixin, chapterMixin } from '@/mixins'

export default {
  name: 'Chapter3',
  data () {
    return {
    }
  },
  mixins: [mediaQueryMixin, scrollPositionMixin, chapterMixin],
  components: {
    CNumber,
    Title,
    Content,
    Rorschach,
    PersonContent,
    Accordion,
    Container,
    SocialSimulation,
    AudioPlayer
  },
  computed: {
    rorschach () {
      return media.chapter3.rorschach
    },
    poster () {
      return media.chapter3.poster
    },
    audio () {
      return media.chapter3.anekdote
    }
  }
}
</script>

<style lang="scss" scoped>
.chapter3 {
  color: white;
  text-align: left;
}
.top {
  padding-top: 75px;
  background-color: $c-dark;
  padding-bottom: 75px;
  position: relative;

  @media (min-width: 768px) {
    padding-top: 175px;
    padding-bottom: 175px;
  }

  &:before, &:after {
    content: '';
    background-size: 740px 166px;
    background-repeat: repeat;
    background-position: top center;
    height: 166px;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1;
  }
  &:before {
    top: -166px;
    background-image: url(~@/assets/images/border.png);
  }
  &:after {
    bottom: -166px;
    background-image: url(~@/assets/images/border_flip.png);
  }
}
.bottom {
  background-color: $c-light;
  padding-bottom: 65px;
  padding-top: 166px;
}
</style>



// WEBPACK FOOTER //
// src/components/chapters/Chapter3.vue